export function isMobile() {
  return /iphone|ipad|ipod|android/i.test(
    window.navigator.userAgent.toLowerCase(),
  );
}
